import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "semantic-ui-react";
import { pdApiActions } from "../../../actions/pdApiActions";
import DropdownField from "../../../components/Editing/DropdownField";
import { getUsergroups } from "../../../utils/pdApiUtils";

interface UserGroupFilterProps {
  target: string; // Adjust the type as needed
}

interface filterType {
  Lift: keyof State.FilterOptions;
  Door: keyof State.FilterOptions;
  Escalator: keyof State.FilterOptions;
}

const UserGroupFilter: React.FC<UserGroupFilterProps> = ({ target }) => {
  const pdApi = useSelector((state: State.Root) => state.pdApi);
  const userGroupsOptions = getUsergroups(pdApi.userGroups);
  const filterOptions = useSelector((state: State.Root) => state.filterOptions);
  const dispatch = useDispatch();

  const filterType: filterType = {
    Lift: "selectedUserGroup",
    Door: "selectedDoorUserGroup",
    Escalator: "selectedEscalatorUserGroup"
  };

  return (
    <Form className="filterForm">
      <DropdownField
        id="kceUserGroupFilter"
        label="UserGroup"
        value={filterOptions[filterType[target as keyof filterType]]}
        options={userGroupsOptions}
        onChange={id => {
          dispatch(
            pdApiActions.setFilterOptions({
              ...filterOptions,
              [filterType[target as keyof filterType] as keyof State.FilterOptions]: id
            })
          );
        }}
      />
    </Form>
  );
};

export default UserGroupFilter;
